import React from 'react'
import styled from 'styled-components'
import SubmitInfo from '@/components/common/submitInfo'
import { createResource, useResource } from '@/lib/i18n'

const resource = createResource({
  en: {
    title: 'Get Exclusive Deal',
    desc: 'Subscribe for Exclusive Voucher and Promo, tips and news',
  },
  id: {
    title: 'Dapatkan penawaran spesial',
    desc: 'Subscribe untuk dapatkan voucher & promo eksklusif dari Kredit Pintar',
  },
})

const Banner = () => {
  const { t } = useResource(resource)

  return (
    <SendMessage>
      <div className="container">
        <div className="left">
          <h2 className="title">{t('title')}</h2>
          <div className="subtitle">{t('desc')}</div>
        </div>
        <SubmitInfo name="message" />
      </div>
    </SendMessage>
  )
}

export default Banner

const SendMessage = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 40px auto 0;
    background-image: url('/images/home/mobile-bg3.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .container {
      width: 100%;
      min-height: 536px;
      .left {
        padding-top: 40px;
        margin: 0 auto;
        width: 272px;
        .title {
          font-size: 24px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
          line-height: 28px;
          padding-bottom: 16px;
        }
        .subtitle {
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 32px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 0 auto;
    background-image: url('/images/home/bg-02.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .container {
      width: 100%;
      height: 408px;
      max-width: 1440px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 0 150px;
      .left {
        padding-top: 88px;
        .title {
          font-size: 36px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
          line-height: 40px;
          padding-bottom: 24px;
        }
        .subtitle {
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 32px;
        }
      }
    }
  }
`
